import { render, staticRenderFns } from "./tukar_projek_owner.vue?vue&type=template&id=448fff7e"
import script from "./tukar_projek_owner.vue?vue&type=script&lang=js"
export * from "./tukar_projek_owner.vue?vue&type=script&lang=js"
import style0 from "./tukar_projek_owner.vue?vue&type=style&index=0&id=448fff7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports